<script lang="ts" module>
  export const ICONS = {
    send: '<path d="M4 12l16-8-6 16-3-6-7-2z" />',
    phone: '<path d="M5 4h4l2 5-3 2a13 13 0 006 6l2-3 5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />',
    phoneOff: '<path d="M3 3l18 18" /><path d="M5 4h4l2 5-3 2a13 13 0 006 6l2-3 3 1" /><path d="M21 4l-6 6" />',
    video: '<rect x="3" y="6" width="12" height="12" rx="2.5" /><path d="M15 10.5l6-3v9l-6-3z" />',
    videoOff: '<rect x="3" y="6" width="12" height="12" rx="2.5" /><path d="M15 10.5l6-3v9l-6-3z" /><path d="M3 3l18 18" />',
    mic: '<rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0014 0M12 18v3" />',
    micOff: '<rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0014 0M12 18v3M4 4l16 16" />',
    screen: '<rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" />',
    settings: '<circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 00.3 1.9l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.9-.3 1.7 1.7 0 00-1 1.6V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.6 1.7 1.7 0 00-1.9.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.9 1.7 1.7 0 00-1.6-1H3a2 2 0 110-4h.1A1.7 1.7 0 004.7 9a1.7 1.7 0 00-.3-1.9l-.1-.1a2 2 0 112.8-2.8l.1.1A1.7 1.7 0 009 4.6h.1a1.7 1.7 0 001-1.6V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.6 1.7 1.7 0 001.9-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.9v.1a1.7 1.7 0 001.6 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />',
    plus: '<path d="M12 5v14M5 12h14" />',
    link: '<path d="M10 13a5 5 0 007 0l2-2a5 5 0 00-7-7l-1 1" /><path d="M14 11a5 5 0 00-7 0l-2 2a5 5 0 007 7l1-1" />',
    close: '<path d="M6 6l12 12M18 6L6 18" />',
    back: '<path d="M15 18l-6-6 6-6" />',
    users: '<circle cx="9" cy="8" r="3.2" /><path d="M3.5 19a5.5 5.5 0 0111 0" /><circle cx="17" cy="9" r="2.6" /><path d="M15.5 19a4.6 4.6 0 014.9-4.5" />',
    reply: '<path d="M9 10L4 15l5 5" /><path d="M4 15h9a7 7 0 007-7V5" />',
    search: '<circle cx="11" cy="11" r="6.5" /><path d="M16 16l4.5 4.5" />',
    check: '<path d="M4 12l5 5L20 6" />',
    trash: '<path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" /><path d="M10 11v5M14 11v5" />',
    switchCamera:
      '<rect x="3" y="6" width="12" height="12" rx="2.5" /><path d="M15 10.5l6-3v9l-6-3z" /><path d="M7 12a2.5 2.5 0 014.5-1.5M11 12a2.5 2.5 0 01-4.5 1.5" /><path d="M11.5 9.2v1.6H10M6.5 13.2v1.6H8" />',
  } as const;

  export type IconName = keyof typeof ICONS;
</script>

<script lang="ts">
  interface Props {
    name: IconName;
    size?: number;
    class?: string;
  }

  let { name, size = 20, class: className = '' }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.8"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}
>
  {@html ICONS[name]}
</svg>
